import Vue from 'vue'
import moment from 'moment'

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', function (value, limit) {
  return value.substring(0, limit)
})

Vue.filter('tailing', function (value, tail) {
  return value + tail
})

Vue.filter('datetime', function (value) {
  if (value.slice(0,1) == '-') {
    return value
  }
  value = String(value)
  const date = value.slice(8, 10)
  const month = value.slice(5, 7)
  const year = value.slice(0, 4)
  // const date = value.slice(3, 5)
  // const month = value.slice(0, 2)
  // const year = value.slice(6, 10)
  const date1 = new Date(Date.parse(value))
  let hours = date1.getHours()
  const min = (date1.getMinutes() < 10 ? '0' : '') + date1.getMinutes()
  const ss = (date1.getSeconds() < 10 ? '0' : '') + date1.getSeconds()

  // if (!fullDate) {
      const time = hours > 12 ? 'PM' : 'AM'
      hours = hours % 12 || 12
      return `${month}/${date}/${year} ${hours}:${min}:${ss} ${time}`
    // }
    // return `${month}/${date}/${year} ${hours}:${min}:${ss} ${time}`
})

Vue.filter('datetime2', function (value) {
  // if (value.slice(0,1) == '-') {
  //   return value
  // }
  if(value == null)
    return value
  value = String(value)
  const date = value.slice(7, 10)
  const month = value.slice(4, 7)
  const year = value.slice(0, 4)
  // const date = value.slice(3, 5)
  // const month = value.slice(0, 2)
  // const year = value.slice(6, 10)
  const date1 = new Date(Date.parse(value))
  let hours = date1.getHours()
  const min = (date1.getMinutes() < 10 ? '0' : '') + date1.getMinutes()
  const ss = (date1.getSeconds() < 10 ? '0' : '') + date1.getSeconds()

  // if (!fullDate) {
      const time = hours > 12 ? 'PM' : 'AM'
      hours = hours % 12 || 12
      return `${year} ${month} ${date} ${hours}:${min}:${ss} ${time}`
    // }
    // return `${month}/${date}/${year} ${hours}:${min}:${ss} ${time}`
})
Vue.filter('time', function (value, is24HrFormat = false) {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'PM' : 'AM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', function (value, fullDate = false) {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  else return `${date} ${month} ${year}`
})

Vue.filter('fulldate', function (value) {
  if (value) { 
    // value = String(moment.utc(value).local().format('YYYY-MM-DD'))
    value = String(value)
    const date = value.slice(7, 10).trim()
    const month = value.slice(4, 7).trim()
    const year = value.slice(0, 4)

    return `${year} ${month} ${date}`
  }
})

Vue.filter('month', function (val, showYear = true) {
  val = String(val)

  const regx = /\w+\s(\w+)\s\d+\s(\d+)./
  if (!showYear) {
    return regx.exec(val)[1]
  } else {
    return `${regx.exec(val)[1]} ${regx.exec(val)[2]}`
  }

})

Vue.filter('csv', function (value) {
  return value.join(', ')
})

Vue.filter('filter_tags', function (value) {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', function (num) {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})
Vue.filter('replace', function (st, rep, repWith) {
  const result = st.split(rep).join(repWith)
  return result
})
